<template>
  <!-- <Header />
  <section class="page-body">
    <Breadcrumb />
    <RouterView />
  </section> -->
  <RouterView />
</template>

<script setup>
  import Header from '@/components/header'
  // import LeftSide from '@/components/leftSide'
  import Breadcrumb from '@/components/breadcrumb'
</script>

<style lang="less">
  *{
    margin: 0;
    padding: 0;
  }
  html, body{
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    color: #333333;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    overflow: hidden;
  }
  #app {
    height: 100vh;
    // background: linear-gradient(180deg, #000000cc -4.37%, #525252cc 121.27%);
    background-image: url('/public/bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
  }
  // common
  .el-checkbox.is-checked .el-checkbox__input {  
      background-color: #4EBE41; /* 选中状态颜色 */  
  }  

  /* 更改悬停状态颜色 */  
  .el-checkbox:hover .el-checkbox__input {  
      background-color: #4EBE41; /* 悬停状态颜色 */  
  }  

  /* 更改激活状态颜色 */  
  .el-checkbox.is-active .el-checkbox__input {  
      background-color: #4EBE41; /* 激活状态颜色 */  
  }

  // :root {
  //   /* 滚动条整体部分，必须要设置 */
  //   ::-webkit-scrollbar {
  //     width: 3px;
  //     height: 10px;
  //     overflow-y: overlay;
  //   }

  //   /* 滚动条里面轨道，能向上向下移动 */
  //   ::-webkit-scrollbar-track {
  //     background-color: transparent;
  //   }

  //   /* 滚动条里面轨道，能向上向下移动 */
  //   ::-webkit-scrollbar-track-piece {
  //     background-color: transparent;
  //   }

  //   ::-webkit-scrollbar-thumb {
  //     display: none;
  //     border-radius: 4px;
  //   }

  //   /* 滚动条里面的小方块，能向上向下移动 */
  //   *:hover::-webkit-scrollbar-thumb {
  //     display: flex;
  //     background-color: #D4D7DF;
  //     border-radius: 4px;
  //   }

  //   *:hover::-webkit-scrollbar-track-piece {
  //     // background-color: #6b7280;
  //   }
  // }
</style>
